import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {CommunicationTypeApi} from '../shared/communication-type.api';
import {CommunicationType} from '../shared/communication-type';
import {Permissions} from '@core/constants/permissions';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonValidators} from "@shared/validators/common.validators";
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'communication-dialog.component.html',
    styleUrls: ['communication-dialog.component.scss'],
    imports: [MatCard, ReactiveFormsModule, MatToolbar, MatSlideToggle, MatTooltip, MatCardContent, MatFormField, MatLabel, MatSelect, MatOption, MatInput, NgxPermissionsModule, MatCardActions, MatButton]
})
export class CommunicationDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CommunicationDialogComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  private communicationTypeApi = inject(CommunicationTypeApi);
  data = inject(MAT_DIALOG_DATA);

  communicationTypes: CommunicationType[];
  editCommunicationForm: UntypedFormGroup;
  permissions: typeof Permissions = Permissions;

  constructor() {
    const data = this.data;

    this.createForm();

    this.editCommunicationForm.patchValue(data.communication.getRawValue());
  }

  ngOnInit(): void {
    this.communicationTypeApi.findAll().subscribe(communicationTypes => {
      this.communicationTypes = communicationTypes;
      if (this.editCommunicationForm.value && !this.editCommunicationForm.value.typeId) {
        this.editCommunicationForm.patchValue({
          typeId: communicationTypes[0].id,
          type: communicationTypes[0]
        });
      }

      const ctype: CommunicationType = this.communicationTypes
        .find(cType => cType.id == this.editCommunicationForm.controls['typeId'].value);

      this.setValidator(ctype.name);
    });

    this.editCommunicationForm.markAllAsTouched();
  }

  createForm() {
    this.editCommunicationForm = this.formBuilder.group({
      id: [],
      typeId: [null, Validators.required],
      type: [null, Validators.required],
      invoice: [false],
      reminder: [false],
      standard: [false],
      value: [null, Validators.required]
    });
  }

  onSave() {
    if(this.editCommunicationForm.valid) {
      this.dialogRef.close(this.editCommunicationForm.value);
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  typeChanged() {
    const ctype: CommunicationType = this.communicationTypes
      .find(cType => cType.id == this.editCommunicationForm.controls['typeId'].value);

    this.editCommunicationForm.patchValue({
      typeId: ctype.id,
      type: ctype
    });

    this.setValidator(ctype.name);
  }

  setValidator(name: string) {
    this.editCommunicationForm.controls['value'].clearValidators();

    switch (name) {
      case 'Email':
        this.editCommunicationForm.controls['value'].setValidators([Validators.required, CommonValidators.email]);
        break;
      case 'Telefoon':
        this.editCommunicationForm.controls['value'].setValidators([Validators.required, CommonValidators.phoneNumber]);
        break;
      case 'Mobiel':
        this.editCommunicationForm.controls['value'].setValidators([Validators.required, CommonValidators.phoneNumber]);
        break;
      case 'Fax':
        this.editCommunicationForm.controls['value'].setValidators([Validators.required, CommonValidators.phoneNumber]);
        break;
      case 'Url':
        this.editCommunicationForm.controls['value'].setValidators([Validators.required, CommonValidators.url]);
        break;
    }
    this.editCommunicationForm.controls['value'].updateValueAndValidity();
  }
}
